import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { TaxIncentive } from '../../../viewmodel';
import { Incentives } from '../../../viewmodel';
import { Animations } from '../../common/animations';

import { CustomValidators } from '../../../directives/validators/custom-validator.directive';
import { HelperService } from '../../../services/helper.service';


@Component({
    selector: 'app-taxincentive',
    templateUrl: './taxincentive.component.html',
    providers: [InformationService, BuildingService],
    styles: ['.rowTemplate4 { min-height: 380px; }'],
    animations: [Animations.flyInOut]
})

export class TaxIncentiveComponent implements OnInit {

    animate: string = 'active';
    animateDirection: number = -1;
    title: string = 'Tax Incentive';
    projectId: number = 0;
    devProjectBuildingId: number = 0;
    siteProjectBuildingId: number = 0;
    buildingId: number = 0;
    buildingAddress: string = '';
    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false;
    submitted: boolean = false;
    questionForm: FormGroup;
    model: TaxIncentive;

    dropdownList = [];

    constructor(private router: Router
        , private activeRoute: ActivatedRoute
        , private formBuilder: FormBuilder
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        , private helperService: HelperService
    ) {

        this.model = new TaxIncentive();
        this.model.ProjectId = this.projectId;
    }

    ngOnInit() {
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
                this.sharedService.navigateHome();
        }

        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjectBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjectBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            if (!(bqp.buildingAddress == null || bqp.buildingAddress == ''))
                this.buildingAddress = '- ' + bqp.buildingAddress;
        }
        else {
            this.sharedService.navigateSummary();
        }
        if (this.siteProjectBuildingId == null || this.buildingId == null)
            this.sharedService.navigateSummary();

        this.questionForm = this.formBuilder.group({
            exemption: ['', Validators.required]
        });

        this.informationService.GetProjectBuildingTaxIncentives(this.devProjectBuildingId, this.siteProjectBuildingId)
            .subscribe(
                success => {
                    if (!success.Success)
                        this.showError(success.StatusMessage);
                    else {
                        if (success.Result != null) {
                            if (success.Result.TaxIncentives != null) {
                                this.dropdownList = success.Result.TaxIncentives;
                                this.PopulateData(success.Result);
                            }
                        }

                        if (this.model.ProjectId == 0 && this.projectId == 0)
                            this.showError("Project ID not found!")
                        else if (this.model.ProjectId == 0)
                            this.model.ProjectId = this.projectId;
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                })

    }

    PopulateData(data) {
        if (data == null || data.length == 0)
            return false;

        if (data.IsRequestingTaxIncentives == true) {
            this.model.IsRequestingTaxIncentives = 'true';
            this.isEdit = true;
        }
        else if (data.IsRequestingTaxIncentives == false) {
            this.model.IsRequestingTaxIncentives = 'false';
            this.isEdit = true;
        }
        else if (data.IsRequestingTaxIncentives == '')
            this.model.IsRequestingTaxIncentives = '';

        this.model.TaxIncentives = data.TaxIncentives;
        this.model.dropdownList = data.TaxIncentives;
    }

    save(button) {

        this.submitted = true;
        if (this.model.IsRequestingTaxIncentives == 'true') {
            if (!this.questionForm.valid) {
                return false;
            }
        }

        if ((this.model.IsRequestingTaxIncentives == null || this.model.IsRequestingTaxIncentives == '')
            || (this.model.IsRequestingTaxIncentives == 'true' && !this.isTaxIncentivesSelected())) {
            return false;
        }

        this.model.IsValid = true;
        if (this.model.IsRequestingTaxIncentives == 'false')
            this.deSelectAll();   // de-select source

        this.informationService.SaveProjectBuildingTaxIncentives(this.model)
            .subscribe(
                success => {
                    if (!success.Success) {
                        this.showError(success.StatusMessage);
                    }
                    else {
                        if (button == 'NEXT') {
                            this.router.navigate(["/buildings/siteunitcount"]);
                        }
                        else if (button == 'LATER')
                            this.sharedService.navigateSummary();
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage);

                })
    }

    isTaxIncentivesSelected(): boolean {
        if (this.dropdownList != null && this.dropdownList.find(x => x.StringTrackingValue == "Y")) {
            return true;
        }
        return false;
    }

    removeSelectedTaxIncentives() {
        if (this.dropdownList != null) {
            this.dropdownList.forEach(x => x.StringTrackingValue = '');
        }
    }

    previous() {
        this.animateDirection = 1;
        this.router.navigate(["/buildings/taxcredit"]);
    }

    home() {
        this.sharedService.navigateHome();
    }

    deSelectAll() {
        if (this.dropdownList != null) {
            for (var i = 0; i < this.dropdownList.length; i++) {
                this.dropdownList[i].StringTrackingValue = '';
            }
        }
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }
}
